module.exports = __webpack_public_path__ + "static/media/move.f0cba90b.svg";